'use strict';

// Vuex
import store from 'store';

async function handleF2fSelection() {
  store.dispatch('questions/selectFace2Face', true);
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  let appointmentStartingQuestion = store.getters['questions/appointmentStartingQuestion'];

  if ( !appointmentStartingQuestion || _.isEmpty(appointmentStartingQuestion) ) { // eslint-disable-line no-undef
    await store.dispatch('questions/requestAppointmentStartingQuestion');
    appointmentStartingQuestion = store.getters['questions/appointmentStartingQuestion'];
  }

  
  const question = _.find(appointmentStartingQuestion.choices, choice => choice.next_question); // eslint-disable-line no-undef

  const data = {
    id: !isAuthenticated ? localStorage.getItem('singleAnswer') : null,
    model: {
      question: appointmentStartingQuestion.id,
      answer: question.text,
    },
  };
  const action = isAuthenticated ? 'appointment/createF2fAppointment' : 'answers/requestUpdateAnswer';

  store.commit('auth/SET_HEADERS', isAuthenticated ? 'fueled' : 'answer');
  return new Promise((resolve, reject) => {
    store.dispatch(action, data)
      .then(response => {
        if ( isAuthenticated ) {
          localStorage.setItem('appointmentSelectionAnswer', response.data.id);
        }

        resolve(response);
      })
      .catch(error => {
        console.error('Something went wrong', error);

        reject(error);
      });
  });
}

function getF2fStartingQuestion() {
  const appointmentStartingQuestion = store.getters['questions/appointmentStartingQuestion'];

  if ( appointmentStartingQuestion ) return _.find(appointmentStartingQuestion.choices, choice => choice.next_question).next_question; // eslint-disable-line no-undef
}

export {
  handleF2fSelection,
  getF2fStartingQuestion,
};



// WEBPACK FOOTER //
// ./client/utils/f2fSelection.js